import React, { useContext } from 'react';

export const SuggestionWebsiteContext = React.createContext('');

// Used for Smart Page custom domain scenario, where the website is not available when the campaign is created
// so we will use smart page free website URL to fetch related suggestions
export const useSuggestionWebsiteContext = () => {
  const website = useContext(SuggestionWebsiteContext);
  return website;
};
